<template>
  <div class="root">
    <BaseCard
      imageURL="rux-how-to.jpg"
      linkURL="https://rux.life/pages/how-to-rux/"
    >
      how to rux</BaseCard
    >
  </div>
</template>

<script>
import BaseCard from './BaseCard'
export default {
  name: 'NotImplemented',
  components: { BaseCard },
}
</script>
